import axios from 'axios';

const extractJSON = response => response.data;

export default ({
  domain, market, device, language, channel, link, accessToken,
}) => axios({
  url: `${domain}/${market}/${channel}/${device}/${language}/appts/emailLink?link=${link}&endpointCd=verifyEmail`,
  method: 'get',
  headers: {
    Authorization: `bearer ${accessToken}`,
    version: '1.18.0',
  },
}).then(extractJSON);
